import type { SubEntryType } from "@tandemdiabetes/sugarmate-api-react-client"
import { ActivityType } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  Label,
  ModalBody,
} from "@tandemdiabetes/sugarmate-react-components"

import { useEntryModalPrivateContext } from "../EntryModalPrivateContext"
import { SubEntryFooter } from "../SubEntryFooter"
import { SubEntryHeader } from "../SubEntryHeader"
import { useUpdateActivity } from "../useUpdateActivity"
import { LiquidRangeInput } from "./LiquidRangeInput"
import { LiquidTypeInput } from "./LiquidTypeInput"

import styles from "src/styles/entryModal.module.scss"
import type {
  EditableSubEntry,
  EditableUserEntry,
} from "src/types"

interface Props {
  currentSubEntry: EditableSubEntry<ActivityType.Liquid>;
  updateSubEntry: (s: Partial<EditableSubEntry<ActivityType.Liquid>>) => void;
  currentUserEntry: EditableUserEntry;
  setCurrentUserEntry: (userEntry: EditableUserEntry) => void;
}

export function LiquidForm(props: Props) {
  const {
    updateSubEntry,
    currentSubEntry,
    currentUserEntry,
    setCurrentUserEntry,
  } = props

  const { liquid: activity } = currentSubEntry

  const updateActivity = useUpdateActivity(
    ActivityType.Liquid,
    activity,
    updateSubEntry,
  )

  const { readOnly } = useEntryModalPrivateContext()

  return (
    <>
      <SubEntryHeader
        activityType={ActivityType.Liquid}
        currentSubEntry={currentSubEntry}
        currentUserEntry={currentUserEntry}
        setCurrentUserEntry={setCurrentUserEntry}
        readOnly={readOnly}
        closeBtnId="liquid-entry-close-btn"
      />
      <ModalBody className={styles.modalBody}>
        {readOnly ? (
          activity?.liquid_type && (
            <Label>
              {activity.liquid_type}
            </Label>
          )
        ) : (
          <LiquidTypeInput
            subentryId={currentSubEntry._id}
            activity={activity}
            updateActivity={updateActivity}
          />
        )}
        <LiquidRangeInput
          activity={activity}
          updateActivity={updateActivity}
          readOnly={readOnly}
        />
        <SubEntryFooter
          currentSubEntry={currentSubEntry}
          currentUserEntry={currentUserEntry}
          updateSubEntry={
            updateSubEntry as (
              s: Partial<EditableSubEntry<SubEntryType>>
            ) => void
          }
          readOnly={readOnly}
        />
      </ModalBody>
    </>
  )
}
